import { Button } from '@/components/ui/atoms/button'
import { cn } from '@/lib/client'
import { useStore } from '@nanostores/react'
import { ChevronDown } from 'lucide-react'
import { atom } from 'nanostores'
import { useEffect, useRef } from 'react'

const continueReadingAtom = atom<boolean>(true)

export default function ContinueReading({
  html = '',
  className,
}: { html: string; className?: string }) {
  const limit = 4000

  const $continueReading = useStore(continueReadingAtom)

  const preview = html && html.length > limit ? html?.slice(0, limit) : html
  const ref = useRef<HTMLDivElement>(null)

  const loadInstagramEmbedScript = () => {
    if (document.getElementById('instagram-embed-script'))
      return Promise.resolve()

    return new Promise<void>((resolve) => {
      const script = document.createElement('script')
      script.id = 'instagram-embed-script'
      script.src = '//www.instagram.com/embed.js'
      script.async = true
      script.defer = true
      script.onload = () => resolve()
      document.body.appendChild(script)
    })
  }

  const processInstagramEmbeds = () => window?.instgrm?.Embeds?.process?.()

  const hasInstagramEmbed = useRef(
    html.includes('instagram.com') ||
      html.includes('blockquote class="instagram-media"'),
  )

  useEffect(() => {
    if (hasInstagramEmbed.current) {
      loadInstagramEmbedScript().then(() => {
        setTimeout(() => {
          processInstagramEmbeds()
        }, 100)
      })

      // Process embeds again if the content changes (e.g., from preview to full content)
      return () => {
        // Clean up if needed
      }
    }
  }, [html, $continueReading])

  return (
    <div className="relative">
      <div
        ref={ref}
        className="mt-5"
        dangerouslySetInnerHTML={{
          __html: !$continueReading ? preview : html || '',
        }}
      />
      {!$continueReading && html.length > limit && (
        <div
          className={cn(
            'inline-block z-10 absolute w-full left-0 -bottom-4 bg-gradient-to-t from-white to-white/50 min-h-[250px] mb-2',
          )}
        >
          <Button
            variant={'default'}
            onClick={() => continueReadingAtom.set(!$continueReading)}
            className={cn(
              'absolute bottom-2 w-full items-center font-medium',
              className,
            )}
          >
            CONTINUAR LENDO
            <ChevronDown
              className="relative top-[1px] ml-1 h-3 w-3 transition group-data-[state=open]:rotate-180 animate-bounce"
              aria-hidden="true"
            />
          </Button>
        </div>
      )}
    </div>
  )
}

// Add TypeScript declaration for the Instagram embed API
declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void
      }
    }
  }
}
